<template>
  <div>
    <header-section></header-section>    
    <booking-info :info_page="info_page"></booking-info>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import BookingInfo from "./components/Booking/BookingInfo.vue";
  import HeaderSection from "./components/Common/HeaderSection.vue";
  export default{
    components: {
      HeaderSection,
      BookingInfo
    },
    data: function(){
      return{
        info_page: {
          counselor: {
            id: '',
            name:  ''
          },          
          list_counselors: [],
          list_service: [],
        }        
      }
    },
    computed:{    
      ...mapGetters( 'user', [
          'isAuthenticated'
      ]),
      ...mapState('user',{
        user_id: state => {
          var user = JSON.parse(state.user)
          return (user.id)
        },
      }),
    },
    mouted(){
      this,$store.watch('user',
      (state, getter) => state.user,
      (new_val, old_val) => {
        // console.log(new_val)
      }
      )
    },
    created: function(){      
    },
    beforeCreaetd: function(){      
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/BookingForm.vue